export default function($) {
  const homeSwiper = new Swiper('.js-home-slider', {
    loop: true,
    slidesPerView: 1,
    speed: 750,
    autoplay: {
      delay: 7000,
      pauseOnMouseEnter: true,
      disableOnInteraction: false,
    },
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
  });
}
